import { callPostApi, callPostFormApi, callGetApi } from '../api-common';
import { Group, User, Profile } from './models';
import { User as ActivateUser } from './InvitationToOrg';

function updateCompany(params: {
  company_id: string;
  name?: string;
  profile: {
    logo_image_file_id: string;
  };
}) {
  return callPostApi('/user/service/company/update/', params);
}
function updateCompanyName(params: {
  company_name: string;
  company_id: string;
}) {
  return callPostApi('/user/service/company/update_name/', params);
}

export function getCompanyUsersCount() {
  return callPostApi('user/company/users_count/') as Promise<{ count: number }>;
}

function uploadCompanyLogo(formData: FormData) {
  return callPostFormApi(
    '/user/service/company/upload_file/',
    formData
  ) as Promise<{
    id: string;
    read_url: string;
  }>;
}

function addLocation(form: Profile) {
  return callPostApi('/user/service/company/add_auxiliary_profile/', form);
}
function updateLocation(form: Profile) {
  return callPostApi('/user/service/company/update_auxiliary_profile/', form);
}
function deleteLocation(form: { profile_id: string }) {
  return callPostApi('/user/service/company/delete_auxiliary_profile/', form);
}
function getLocations() {
  return callPostApi('/user/service/company/query_profiles/') as Promise<
    Profile[]
  >;
}
function setUserOrgProfile(form: { user_id: string; org_profile_id: string }) {
  return callPostApi('/user/service/company/set_user_org_profile/', form);
}
function removeUser(form: { user_id: string }) {
  return callPostApi('/user/service/company/remove_user/', form);
}
function addUser(form: { email: string }) {
  return callPostApi('/user/service/company/add_user/', form);
}

export function fetchUserGroups(org_id: string) {
  return callPostApi('/user/service/company/groups/', {
    org_id,
    page_no: 1,
    page_size: -1,
  }) as Promise<{ result: Group[] }>;
}

function addUserGroup(form: { name: string; description?: string }) {
  return callPostApi(
    '/user/service/company/groups/add/',
    form
  ) as Promise<string>;
}

function updateUserGroup(form: {
  id: string;
  name: string;
  description?: string;
}) {
  return callPostApi('/user/service/company/groups/update/', form);
}

function deleteUserGroup(id: string) {
  return callPostApi('/user/service/company/groups/remove/', { group_id: id });
}

export function fetchGroupUsers(form: {
  group_id: string;
  org_id: string;
}): Promise<User[]> {
  return callGetApi('/user/service/company/groups/users/', form);
}

function batchAddUser(form: { group_id: string; users_id: string[] }) {
  return callPostApi('/user/service/company/groups/batch_add_user/', form);
}

function batchRemoveUser(form: { group_id: string; users_id: string[] }) {
  return callPostApi('/user/service/company/groups/batch_remove_user/', form);
}

function changePwdForMember(form: { user_id: string; password: string }) {
  return callPostApi(
    '/user/service/company/user/admin_change_member_pwd/',
    form
  );
}

// function cancelInvitation(user_id: string) {
//   return callPostApi('/user/service/company/user/cancel_invitation/', {
//     user_id: user_id,
//   });
// }

function cancelInvitation2(invitation_id: string) {
  return callPostApi('/user/service/company/user/cancel_invitation/v2/', {
    invitation_id: invitation_id,
  });
}

function activateAccount(verify_key: string) {
  return callPostApi('/user/service/userAuth/activate_account/', {
    k: verify_key,
  }) as Promise<{
    user_id: string;
    username: string;
    orgname: string;
    inviter: string;
    invite_time: string;
    invite_source: string;
  }>;
}

function resetPassword(user: ActivateUser, verify_key: string) {
  return callPostApi('/user/service/userAuth/resetpwd/', {
    k: verify_key,
    user_id: user.user_id,
    password: user.password1,
    params: {
      first_name: user.firstname,
      last_name: user.lastname,
      phone: user.phone,
    },
  }) as Promise<{ message: string }>;
}

export function setAccountActive(user: ActivateUser, verify_key: string) {
  return callPostApi('/user/service/userAuth/activate/', {
    k: verify_key,
    user_id: user.user_id,
    password: user.password1,
    params: {
      first_name: user.firstname,
      last_name: user.lastname,
      phone: user.phone,
    },
  });
}

export function queryCompanyUser() {
  return callPostApi('/user/service/company/users/') as Promise<{
    users: User[];
  }>;
}

function updateUserRole(user_id: string, roles: string[]) {
  return callPostApi('/user/service/company/update_user_role/', {
    user_id,
    roles,
  });
}

function batchUpdateUseRole(items: { user_id: string; roles: string[] }[]) {
  return callPostApi('/user/service/company/batch_update_user_role/', {
    items: items,
  });
}

function batchSetUserOrgProfile(
  params: { user_id: string; org_profile_id: string }[]
) {
  return callPostApi('/user/service/company/batch_set_user_org_profile/', {
    items: params,
  });
}

function queryCompanyUserInVerify() {
  return callPostApi('/user/service/company/users_in_inviting/') as Promise<{
    users: User[];
  }>;
}

export default {
  removeUser,
  updateCompany,
  uploadCompanyLogo,
  updateCompanyName,
  addLocation,
  updateLocation,
  deleteLocation,
  getLocations,
  setUserOrgProfile,
  addUser,
  fetchUserGroups,
  addUserGroup,
  updateUserGroup,
  deleteUserGroup,
  fetchGroupUsers,
  batchAddUser,
  batchRemoveUser,
  changePwdForMember,
  // cancelInvitation,
  cancelInvitation2,
  activateAccount,
  resetPassword,
  queryCompanyUser,
  queryCompanyUserInVerify,
  updateUserRole,
  batchUpdateUseRole,
  batchSetUserOrgProfile,
};
